module.exports = __webpack_public_path__ + "img/next.b2950408.png";